<template>
	<div>
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../../assets/images/htgl2.png" class="steps step1" v-if="status==1">
			<img src="../../../assets/images/htgl1.png" class="steps step2" v-if="status==2">
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"我知道了":"我知道了"}}
			</div>
         <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
		<breadcrumb :routerList="[{to:'/contract-list',title:'合同管理'},{title:'新建LEG合同'}]"/>
		<div class="h-content" :class="{'ljjtips':cgflag || zlflag || dlsflag}">
			<div class="h-piece">
				<div class="h-formLine weekplandetail21">
					<el-form label-position="right" ref="form1" :model="formInline" :rules="rules" :inline="true"  class="demo-ruleForm h-formbLine">
					  <el-form-item label="合同名称" class="h-elformWrap-2" prop="contractName">
						<el-input v-model="formInline.contractName" placeholder="请输入合同名称"></el-input>
					  </el-form-item>
					  <el-form-item label="合同类型" class="h-elformWrap-2" prop="contractCatecory">
						<brselect category="contract_category" @input="changeCatogory" @change="changeProject" :v="formInline.contractCatecory" v-model="formInline.contractCatecory" style="width:3.1rem"/>
					  </el-form-item>
						<el-form-item label="商务合同号" class="h-elformWrap-2" prop="businessContractCode">
							<el-input v-model="formInline.businessContractCode" placeholder="请输入商务合同编号"></el-input>
						</el-form-item>
					  <el-form-item label="关联项目" class="h-elformWrap-2" prop="pid" v-if="!zlflag && !dlsflag">
						<el-select v-model="formInline.pid"
						           placeholder="--请选择关联项目--" clearable filterable @change="changeProject">
						    <el-option v-for="(item,index) in allProjectByUser"
						               :key="index"
						               :label="item.projectName"
						               :value="item.id">
						        {{ item.projectName }}
						    </el-option>
						</el-select>
					  </el-form-item>
					  <el-form-item :label="customerlabel" class="h-elformWrap-2" prop="customerCode">
						<el-select placeholder="--请先选择合同类型--" filterable v-model="formInline.customerCode" @change="fillCusName" id="customer">
						  <el-option v-for="customer in customerList" :key="customer.usercode" :label="customer.username" :value="customer.usercode"></el-option>
						</el-select>
					  </el-form-item>
					  <el-form-item label="租赁时间" class="h-elformWrap-2" prop="rentTime" v-if="zlflag">
						  <el-col class="yearIcon">
							  <el-input v-model.number="formInline.rentTime" placeholder="请输入租赁时间">
							  </el-input>
						  </el-col>
					  </el-form-item>
					  <!-- <el-form-item label="保修时间" class="h-elformWrap-2" prop="guaranteeTime" v-if="zlflag">
						<el-col class="yearIcon">
							<el-input v-model.number="formInline.guaranteeTime" placeholder="请输入保修时间">
							</el-input>
						</el-col>
					  </el-form-item> -->
					  <el-form-item label="LEG合同编号" class="h-elformWrap-2" prop="contractCode">
					  	<el-input v-model="formInline.contractCode" placeholder="请输入" @blur="getLEG"></el-input>
					  </el-form-item>
					  <el-form-item label="销售渠道" class="h-elformWrap-2" prop="salechannelCode" v-if="!cgflag&&!zlflag">
						<brselect category="sales_region" :v="formInline.salechannelCode" v-model="formInline.salechannelCode" style="width:3.1rem"/>
					  </el-form-item>
					  <el-form-item label="合同金额" class="h-elformWrap-2 h-moneyIcon" prop="contractAmount" v-if="!cgflag">
						<el-input v-model.number="formInline.contractAmount" placeholder="请输入数字"></el-input>
					  </el-form-item>
					   <el-form-item label="合同状态" class="h-elformWrap-2" prop="contractStatus">
						<brselect category="contract_status" :v="formInline.contractStatus" v-model="formInline.contractStatus" style="width:3.1rem"/>
					  </el-form-item>
					   <el-form-item label="合同开始时间" class="h-elformWrap-2" prop="contractStarttime">
						<el-date-picker :clearable="false" :picker-options="pickerOptions1" type="date" placeholder="选择时间" v-model="formInline.contractStarttime"></el-date-picker>
					  </el-form-item>
					  <el-form-item label="合同结束时间" class="h-elformWrap-2" prop="contractEndtime">
						<el-date-picker :clearable="false" :picker-options="pickerOptions2" type="date" placeholder="选择时间" v-model="formInline.contractEndtime"></el-date-picker>
					  </el-form-item>
						<el-form-item label="付款日期" class="h-elformWrap-2" prop="payDate">
							<el-date-picker :clearable="false" type="date" placeholder="选择时间" v-model="formInline.payDate"></el-date-picker>
						</el-form-item>
					</el-form>
					<el-form label-position="right" :model="formInline1" ref="form2" :rules="rules" :inline="true"
					 class="demo-ruleForm h-formbLine" v-if="!zlflag && !bzflag && !dlsflag">
						<el-form-item label="付款条件" class="h-elformWrap-1" prop="condition" v-if="!cgflag && !dlsflag">
							<div class="h-checkBox">
								<el-checkbox-group v-model="formInline1.condition">
									<el-checkbox label="现金"></el-checkbox>
									<el-checkbox label="信贷"></el-checkbox>
								 </el-checkbox-group>
							</div>
						</el-form-item>
<!--						<el-form-item label="物流方式" class="h-elformWrap-1" prop="wuliufangshi"  v-if="cgflag">
							<div class="h-checkBox">
								<el-radio-group v-model="formInline1.wuliufangshi">
									<el-radio :label="1">海尔自有物流</el-radio>
									<el-radio :label="2">供应商直发</el-radio>
									<el-radio :label="3">两者皆可</el-radio>
								 </el-radio-group>
							</div>
						</el-form-item>-->
					</el-form>
				</div>
				<div v-if="cgflag">
				<div class="h-pieceTitle2" style="margin:5px 0 16px 10px">
					<h1>产品信息</h1>
				</div>
				<el-form ref="form5" :model="formInline">
				 <el-table
				        ref="multipleTable"
				        :data="formInline.productList"
				        style="width: 100%"
				        >
				        <el-table-column
				        type="index"
				        label="#" width="40">
				        </el-table-column>
				        <el-table-column
				        prop="productId"
				        label="产品型号" width="180">
				        </el-table-column>
				        <el-table-column
				        prop="productName"
				        label="产品名称" width="240">
				        </el-table-column>
				        <el-table-column
				        prop="unitPrice"
				        label="产品价格" width="160">
				        </el-table-column>
					 <el-table-column
							 prop="currency"
							 min-width="100"
							 :show-overflow-tooltip="true"
							 label="币种">
						 <template slot-scope="scope">
							 {{scope.row.currency | dictname('YLCurrency')}}
						 </template>
					 </el-table-column>
				        <el-table-column
				        prop="shuilv"
				        label="发票税率" width="140">
				            <template scope="scope">
								<brselect category="cgshuilv" :v="scope.row.shuilv" v-model="scope.row.shuilv" />
				            </template>
				        </el-table-column>
					 <el-table-column
							 prop="cgjingli"
							 label="采购经理">
						 <template scope="scope">
							 <brselect :multiple="true" category="cg_manage" v-model="scope.row.cgjingli" :v="scope.row.cgjingli"/>
						 </template>
					 </el-table-column>
				    </el-table>
					</el-form>
				</div>
				<div v-if="zlflag">
				<div class="h-pieceTitle2" style="margin:25px 0 16px 10px">
					<h1>租赁型号</h1>
				</div>
				<el-form ref="form5" :model="formInline" :rules="rules1">
				 <el-table
				        ref="multipleTable"
				        :data="formInline.zlList"
				        style="width: 100%"
				        >
				        <el-table-column
				        type="index"
				        width="40"
				        label="#">
				        </el-table-column>
				        <el-table-column
				        prop="productType"
				        label="产品大类">
				            <template scope="scope">
								<el-form-item :prop="'zlList.'+scope.$index+'.productType'" :rules="rules1.productType"  style="margin-bottom: 0;">
									<el-select v-model="scope.row.productType"
									style="width: 100%;"
											   placeholder="--请选择产品大类--" clearable @change="changeBig(scope.row)">
										<el-option v-for="item in optionsProduct1"
												   :key="item.id"
												   :label="item.levelname"
												   :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
				            </template>
				        </el-table-column>
						<el-table-column
						prop="productCode"
						label="产品型号">
						    <template scope="scope">
								<el-form-item :prop="'zlList.'+scope.$index+'.productCode'" :rules="rules1.productCode"  style="margin-bottom: 0;">
									<el-select v-model="scope.row.productCode" style="width: 100%;" placeholder="--请选择产品型号--" filterable @change="fillProductName(scope.row)">
									    <el-option
									        v-for="item in scope.row.optionsProduct2"
									        :key="item.id"
									        :label="item.levelname"
									        :value="item.id">
									    </el-option>
									</el-select>
								</el-form-item>
						    </template>
						</el-table-column>
						<el-table-column
						prop="rentNum"
						label="租赁数量">
						    <template scope="scope">
								<el-form-item :prop="'zlList.'+scope.$index+'.rentNum'" :rules="rules1.rentNum"  style="margin-bottom: 0;">
									<el-input v-model.number="scope.row.rentNum" placeholder="请输入租赁数量"></el-input>
								</el-form-item>
						    </template>
						</el-table-column>
						<el-table-column
						prop="productUnitPrice"
						label="产品单价">
						    <template scope="scope">
								<el-form-item :prop="'zlList.'+scope.$index+'.productUnitPrice'" :rules="rules1.productUnitPrice"  style="margin-bottom: 0;">
									<el-input v-model.number="scope.row.productUnitPrice" placeholder="请输入产品单价"></el-input>
								</el-form-item>
						    </template>
						</el-table-column>
				        <el-table-column
				            label="操作"
								fixed="right"
				            width="150">
				            <template slot-scope="scope">
				                <el-button type="text" @click="delIndex1(scope.$index)">删除</el-button>
				            </template>
				        </el-table-column>
				    </el-table>
					</el-form>
				    <div class="h-tableAdd" @click="adds1">
				        <a>新增一行</a>
				    </div>
				</div>
				<div v-if="cgflag || zlflag">
					<div class="h-pieceTitle2" style="margin:25px 0 16px 10px">
						<h1>付款节点</h1>
					</div>
				<el-form ref="form3" :model="formInline" :rules="rules">
				 <el-table
				        ref="multipleTable"
				        :data="formInline.paymentList"
				        style="width: 100%"
				        >
				        <el-table-column
				        type="index"
				        width="40"
				        label="#">
				        </el-table-column>
				        <el-table-column
				        prop="nodeName"
				        label="节点名称">
				            <template scope="scope">
									 <!-- :rules="rules.nodeName" -->
								<el-form-item :prop="'paymentList.'+scope.$index+'.nodeName'" :rules="rules.nodeName"  ref="bili2" style="margin-bottom: 0;">
									<brselect category="payment_node" :v="scope.row.nodeName" v-model="scope.row.nodeName" clearable />
								</el-form-item>
				            </template>
				        </el-table-column>
				        <el-table-column
				        prop="paymentRatio"
				        label="付款比例(%)" width="150">
				            <template scope="scope">
				        		<el-form-item :prop="'paymentList.'+scope.$index+'.paymentRatio'" :rules="rules.paymentRatio"  style="margin-bottom: 0;">
				        			<el-input @blur="linkMoney(scope.$index,'ratio')" v-model="scope.row.paymentRatio"></el-input>
				        		</el-form-item>
				            </template>
				        </el-table-column>
						<el-table-column
						prop="paymentAmount"
						label="开票金额(元)" width="150" v-if="zlflag">
						    <template scope="scope">
								<el-form-item :prop="'paymentList.'+scope.$index+'.paymentAmount'" :rules="rules.paymentAmount"  style="margin-bottom: 0;">
									<el-input @blur="linkMoney(scope.$index,'amount')" v-model="scope.row.paymentAmount"></el-input>
								</el-form-item>
						    </template>
						</el-table-column>
						<el-table-column
						prop="netValue"
						label="净价值(元)" width="150" v-if="zlflag">
						    <template scope="scope">
								<el-form-item :prop="'paymentList.'+scope.$index+'.netValue'" :rules="rules.netValue"  style="margin-bottom: 0;">
									<el-input @blur="linkMoney(scope.$index,'net')" v-model="scope.row.netValue"></el-input>
								</el-form-item>
						    </template>
						</el-table-column>
<!--				        <el-table-column-->
<!--				        prop="paymentDays"-->
<!--				        label="账期(天)"-->
<!--				        width="150">-->
<!--				            <template scope="scope">-->
<!--								<el-form-item :prop="'paymentList.'+scope.$index+'.paymentDays'" :rules="rules.paymentDays" style="margin-bottom: 0;">-->
<!--									<el-input v-model.number="scope.row.paymentDays" oninput="value=value.replace(/[^\d]/g, '')" ref="bili1"></el-input>-->
<!--								</el-form-item>-->
<!--				            </template>-->
<!--				        </el-table-column>-->
						<el-table-column
						prop="billDate"
						label="计划开票时间"
						width="250" v-if="zlflag">
						    <template scope="scope">
								<el-form-item :prop="'paymentList.'+scope.$index+'.billDate'" :rules="rules.billDate"  style="margin-bottom: 0;">
									<el-date-picker :clearable="false" type="date" placeholder="选择时间" v-model="scope.row.billDate"></el-date-picker>
								</el-form-item>
						    </template>
						</el-table-column>
				        <!--<el-table-column
				        prop="isNeedcred"
				        label="是否需要凭证"
				        width="200" v-if="cgflag">
				            <template scope="scope">
								<el-form-item :prop="'paymentList.'+scope.$index+'.isNeedcred'" :rules="rules.isNeedcred" style="margin-bottom: 0;">
									<el-radio-group v-model="scope.row.isNeedcred" @change="isshow">
										<el-radio :label="1">是</el-radio>
										<el-radio :label="0">否</el-radio>
									</el-radio-group>
								</el-form-item>
				            </template>
				        </el-table-column>-->
				        <el-table-column
				            label="操作"
								fixed="right"
				            width="200">
				            <template slot-scope="scope">
				                <el-button type="text" size="small" v-if="scope.row.newflag" @click="delIndex(scope.$index)">删除</el-button>
								<el-button type="text" size="small" v-if="scope.row.newflag" @click="copyIndex(scope.row)">复制</el-button>
				            </template>
				        </el-table-column>
				    </el-table>
					</el-form>
				    <div class="h-tableAdd" @click="adds">
				        <a>新增一行</a>
				    </div>
				</div>

				<div v-if="zlflag" style="margin-top: 0.3rem;">
				<el-form ref="form6" :model="formInline" :rules="rules">
				 <el-table
				        ref="multipleTable"
				        :data="formInline.fukuanobj"
				        style="width: 100%"
				        >
				        <el-table-column
				        type="index"
				        width="40"
				        label="#">
				        </el-table-column>
				        <el-table-column
				        prop="nodeName"
				        label="节点名称">
				            <template scope="scope">
								<el-form-item :prop="'fukuanobj.'+scope.$index+'.nodeName'" :rules="rules.nodeName"  style="margin-bottom: 0;">
				                <el-input v-model="scope.row.nodeName" :readonly="!scope.row.newflag"></el-input>
								</el-form-item>
				            </template>
				        </el-table-column>
				        <el-table-column
				        prop="paymentRatio"
				        label="付款比例(%)" width="150">
				            <template scope="scope">
								<el-form-item :prop="'fukuanobj.'+scope.$index+'.paymentRatio'" :rules="rules.paymentRatio"  style="margin-bottom: 0;">
									<el-input @blur="linkMoney(scope.$index,'yj')" v-model="scope.row.paymentRatio"></el-input>
								</el-form-item>
				            </template>
				        </el-table-column>
						<el-table-column
						prop="paymentAmount"
						label="付款金额(元)" width="150">
						    <template scope="scope">
								<el-form-item :prop="'fukuanobj.'+scope.$index+'.paymentAmount'" :rules="rules.paymentAmount"  style="margin-bottom: 0;">
									<el-input  v-model="scope.row.paymentAmount"></el-input>
								</el-form-item>
						    </template>
						</el-table-column>
						<el-table-column
						prop="netValue"
						label="净价值(元)" width="150">
						    <template scope="scope">
								<el-form-item :prop="'fukuanobj.'+scope.$index+'.netValue'" :rules="rules.netValue"  style="margin-bottom: 0;">
									<el-input  v-model="scope.row.netValue"></el-input>
								</el-form-item>
						    </template>
						</el-table-column>
				        <el-table-column
				        prop="paymentDays"
				        label="账期(天)"
				        width="150">
				            <template scope="scope">
								<el-form-item :prop="'fukuanobj.'+scope.$index+'.paymentDays'" :rules="rules.paymentDays"  style="margin-bottom: 0;">
									<el-input v-model.number="scope.row.paymentDays" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
								</el-form-item>
				            </template>
				        </el-table-column>
				    </el-table>
					</el-form>
				</div>
				<div class="h-pieceInCon3 h-mrt0 h-mrl100" style="margin-bottom:50px;" v-if="!cgflag && !zlflag && !bzflag && !dlsflag">
					<div class="h-formLine h-mrb-38">
						<el-form :model="formInline" label-position="right" :rules="rules" :inline="true"  class="demo-ruleForm h-formbLine">
						  <el-form-item label="现金" class="h-elformWrap-2" prop="cashRatio">
							<el-col :span="10" class="h-percentageIcon">
							  <el-input v-model="formInline.cashRatio" placeholder="请输入数字" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
							</el-col>
							<el-col class="line h-txtCenter h-zIcon" :span="4"><img src="../../../assets/images/h-zhunhua-icon.png"></el-col>
							<el-col :span="10" class="h-moneyIcon2">
							  <el-input v-model="formInline.cashAmount" placeholder="请输入数字" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
							</el-col>
						  </el-form-item>
						  <el-form-item label="信贷" class="h-elformWrap-2" prop="creditRatio">
							<el-col :span="10" class="h-percentageIcon">
							  <el-input v-model="formInline.creditRatio" placeholder="请输入数字" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
							</el-col>
							<el-col class="line h-txtCenter h-zIcon" :span="4"><img src="../../../assets/images/h-zhunhua-icon.png"></el-col>
							<el-col :span="10" class="h-moneyIcon2">
							  <el-input v-model="formInline.creditAmount" placeholder="请输入数字" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
							</el-col>
						  </el-form-item>
						</el-form>
					</div>
				</div>
			</div>
			<div class="h-txtCenter h-mrt60">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
				<el-button class="h-btn h-bBtn h-bggreen" @click="save">暂存</el-button>
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="submit">确认提交</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import big from 'big.js';
	import ss from "../../../api/SystemService";
	import util from "../../../utils/util";
    export default {
        name:'leftMenu',
        data() {
            return {
				CGJLList:[],
				toshow:"contract-new1",
				showOrhide:false,
				status:1,
				checked:true,
				optionsProduct2:[],
				optionsProduct1:[],
				kong:'',
				customerlabel:"客户名称",
				companycode:"",
				allProjectByUser:"",
				tempProject:"",
				tempProject2:"",
				cgflag:false,
				zlflag:false,
				bzflag:false,
				dlsflag:false,
				pickerOptions1:{
					disabledDate: (time)=>{
						if (this.formInline.contractEndtime != "") {
							return time.getTime() > this.formInline.contractEndtime;
						}
					}
				},
				pickerOptions2:{
					disabledDate: (time)=>{
						if (this.formInline.contractStarttime != "") {
							return time.getTime() < this.formInline.contractStarttime;
						}
					}
				},
				//表单
				formInline:{
					contractName:"",
					pid:"",
					customerCode:"",
					salechannelCode:"",
					contractCatecory:"",
					contractAmount:"",
					contractStatus:"",
					contractStarttime:"",
					contractEndtime:"",
					contractCode:"",
					contractCashPledge:"",
					paymentList:[{nodeName:"",newflag:false,paymentRatio:"",
							paymentAmount:"",netValue:"",paymentDays:"",isNeedcred:"",billDate:""}],
					zlList:[
						{
							productType:'',
							productCode:'',
							rentNum:'',
							productName:'',
							productUnitPrice:'',
							pickerOptions2:[]
						}
					],

					fukuanobj:[
						{
							nodeName:"押金",
							newflag:false,
							paymentRatio:"",
							paymentAmount:"",
							netValue:"",
							paymentDays:"",
							billPayMonty:""
						}
					],
					productCode:"",
					productName:"",
					productPrice:"",
					productList:[],
					payDate:"",
					businessContractCode:"",
				},
				formInline1:{
					wuliufangshi: 2,
					condition:[]
				},
				contractId:this.$route.query.contractId,
				customerList: [],
				//多选
				checkList:[],
				fileList:[],
				file:{},
				rules1:{
					productType:[
						{ required: true, message: '请选择产品大类', trigger: 'change' },
					],
					productCode:[
						{ required: true, message: '请选择产品型号', trigger: 'change' },
					],
					rentNum:[
						{ required: true, message: '请输入租赁数量', trigger: 'blur' },

					],
					productUnitPrice:[
						{ required: true, message: '请输入型号单价', trigger: 'blur' },

					],
				},
				rules:{
					contractName: [
						{ required: true, message: '请输入合同名称', trigger: 'blur' },
					],
					pid: [
                    	{ required: true, message: '请输入关联项目编码', trigger: 'blur' },
					],
					customerCode: [
                    	{ required: true, message: '请选择客户名称', trigger: 'change' },
					],
					salechannelCode: [
                    	{ required: true, message: '请选择销售渠道', trigger: 'blur' },
					],
					contractCatecory: [
						{ required: true, message: '请选择合同类型', trigger: 'change' },
					],
					contractAmount: [
						{ required: true, message: '请先输入客户名称和LEG合同编号', trigger: 'blur' },
						{ type : 'number', message:"必须为数字值"}
					],
					contractCashPledge:[
						{ required: true, message: '请输入押金金额', trigger: 'blur' },
						{ type : 'number', message:"必须为数字值"}
					],
					contractStatus: [
						{ required: true, message: '请选择合同状态', trigger: 'blur' },
					],
					contractStarttime: [
						{ required: true, message: '请输入合同开始时间', trigger: 'blur' },
					],
					contractEndtime: [
						{ required: true, message: '请输入合同结束时间', trigger: 'blur' },
					],
					condition: [
						{ required: true, message: '请输入付款条件', trigger: 'blur' },
					],
					contractCode: [
						{ required: true, message: '请输入LEG合同编号', trigger: 'blur' },
					],
					productCode: [
						{ required: true, message: '请先选择关联项目', trigger: 'blur' },
					],
					productName: [
						{ required: true, message: '请先选择关联项目', trigger: 'blur' },
					],
					shuilv: [
						{ required: true, message: '请输入发票税率', trigger: 'change' },
						{ type : 'number', message:"必须为数字值"}
					],
					/*wuliufangshi:[
						{ required: true, message: '请选择物流方式', trigger: 'change' },
					],*/
					nodeName:[
						{ required: true, message: '请输入节点名称', trigger: 'blur' },
					],
					paymentRatio:[
						{ required: true, message: '请输入付款比例', trigger: 'blur' },
					],
					paymentAmount:[
						{ required: true, message: '请输入付款金额', trigger: 'blur' },
					],
					netValue:[
						{ required: true, message: '请输入净价值', trigger: 'blur' },
					],
/*					paymentDays:[
						{ required: true, message: '请输入账期', trigger: 'blur' },
					],*/
/*					isNeedcred:[
						{ required: true, message: '请选择是否需要凭证', trigger: 'change' },
					],*/
					productPrice:[
						{ required: true, message: '请先选择关联项目', trigger: 'blur' },
					],

					rentTime:[
						{ required: true, message: '请输入租赁时间', trigger: 'blur' },
						{ type : 'number', message:"必须为数字值"}
					],
					guaranteeTime:[
						{ required: true, message: '请输入保修时间', trigger: 'blur' },
						{ type : 'number', message:"必须为数字值"}
					],
					billDate:[
						{ required: true, message: '请输入计划开票日期', trigger: 'blur' },
					],
					businessContractCode:[
						{ required: true, message: '请输入商务合同编号', trigger: 'blur' }
					],
					payDate: [
						{ required: true, message: '请输入付款日期', trigger: 'blur' },
					],
				}
            }
        },
        methods: {
			linkMoney(index,data){
				if(data == "ratio") {
					this.formInline.paymentList[index].paymentAmount=new big(this.formInline.contractAmount).times(this.formInline.paymentList[index].paymentRatio).div(100).toFixed(2).toString();
					this.formInline.paymentList[index].netValue=new big(this.formInline.paymentList[index].paymentAmount).div(1.13).toFixed(2).toString();
				}else if(data == "amount"){
					this.formInline.paymentList[index].paymentRatio=new big(this.formInline.paymentList[index].paymentAmount).div(this.formInline.contractAmount).times(100).toFixed(2).toString();
					this.formInline.paymentList[index].netValue=new big(this.formInline.paymentList[index].paymentAmount).div(1.13).toFixed(2).toString();
				}else if(data == "net"){
					this.formInline.paymentList[index].paymentAmount=new big(this.formInline.paymentList[index].netValue).times(1.13).toFixed(2).toString();
					this.formInline.paymentList[index].paymentRatio=new big(this.formInline.paymentList[index].paymentAmount).div(this.formInline.contractAmount).times(100).toFixed(2).toString();
				}else if (data == "yj") {
								this.formInline.fukuanobj[index].paymentAmount=new big(this.formInline.contractAmount).times(this.formInline.fukuanobj[index].paymentRatio).div(100).toFixed(2).toString();
						this.formInline.fukuanobj[index].netValue=new big(this.formInline.fukuanobj[index].paymentAmount).div(1.13).toFixed(2).toString();
					}

			},
			isshow(v){
				this.kong = v
			},
			delIndex(index){
			    this.formInline.paymentList.splice(index, 1)
			},
			delIndex1(index){
			    this.formInline.zlList.splice(index, 1)
			},
			copyIndex(data){
				this.formInline.paymentList.push({nodeName:data.nodeName,paymentRatio:data.paymentRatio,paymentDays:data.paymentDays,
							isNeedcred:data.isNeedcred,newflag:true,billDate:data.billDate,billPayMonty:data.billPayMonty});
			},
			adds(){
			    var a = {nodeName:"",paymentRatio:"",paymentAmount:"",netValue:"",
							paymentDays:"",isNeedcred:"",newflag:true,billDate:"",billPayMonty:""};
			    this.formInline.paymentList.push(a)
			},
			adds1(){
				var a = {productType:"",productCode:"",rentNum:"",productUnitPrice:""};
				this.formInline.zlList.push(a)
			},
			changeProject(){
				this.customerList = [];
				this.formInline.customerCode = null;
				if(this.formInline.contractCatecory == "CT-CG") {
					ss.contractService.getFinalSuppliers({projectId:this.formInline.pid}).then(rd=>{
						if(rd!=null && rd.length>0){
							_.forEach(rd,(value)=>{
								this.customerList.push({"usercode":value.final_supplier,"username":value.final_supplier_name});
							})
						}
					})
				}
			},
			fillCusName(data){
				let obj = {};
				obj = this.customerList.find((item)=>{
					return item.usercode === data;
				});
				this.formInline.customerName = obj.username;
				this.companycode = obj.companycode;
				if(this.formInline.contractCatecory=="CT-CG"){
					ss.contractService.getProductInfoBySupplier({"projectId":this.formInline.pid,"finalSupplier":data}).then(rd=>{
						this.formInline.productList = rd;
					})
				}
				this.getLEG();
			},
			fillProductName(data){
					data.optionsProduct2.forEach(res=>{
					console.log(res.id,res.levelname,"/././..")
						if(res.id == data.productCode){
							data.productName = res.levelname;
						}
					})
			},
			cancel(){
				this.$router.push("contract-list");
			},
			save(){
				this.formInline.editStatus = 0;
				var cond = this.formInline1.condition;
				this.formInline.payCondition = cond.join(",");
				this.formInline.contractType = 1;
				this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
				this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
				this.formInline.payDate = this.formatDate(this.formInline.payDate);
				this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
				if (this.formInline.paymentList) {
					this.formInline.paymentList.forEach((obj)=>{
						obj.billDate = this.formatDate(obj.billDate);
					})
				}
				this.formInline.zlList = this.formInline.zlList;
				ss.contractService.insert(this.formInline).then(rd=>{
					if(rd.f){
						this.$msg.msgs("保存成功！");
						this.$router.push("contract-list");
					}else{
						this.$msg.msge("保存失败！"+rd.msg);
					}
				})
			},
			submit(){

				var subflag1 = false;
				var subflag2 = false;
				var subflag3 = false;
				var subflag4 = false;
				this.$refs['form1'].validate((valid) => {
				    if (valid){
				        subflag1=true;
				    }else{
				        this.$msg.msge("请完善合同信息后再提交！");
				        return false;
				    }
				});
				if (!subflag1) {
					return;
				}
				var cate = this.formInline.contractCatecory;
				if (cate != "CT-ZL" && cate != "CT-BZ" && cate != "CT-DLS-KJ") {
					this.$refs['form2'].validate((valid) => {
					    if (valid){
					        subflag2=true;
					    }else{
					        this.$msg.msge("请完善合同信息后再提交！");
					        return false;
					    }
					});
					if (!subflag2) {
						return;
					}
				}

				if (cate == "CT-CG" || cate == "CT-ZL"){
					this.$refs['form3'].validate((valid) => {
					    if (valid){
					        subflag3=true;
							if(cate = "CT-CG"){
								this.formInline.productList.forEach(e =>{
									if(e.shuilv == null){
										this.$msg.msge("请选择发票税率后再提交！");
										subflag3=false;
										return false;
									}
								})
							}
					    }else{
					        this.$msg.msge("请完善合同信息后再提交！");
					        return false;
					    }
					});
					this.$refs['form5'].validate((valid) => {
					    if (valid){
					        subflag4=true;
					    }else{
					        this.$msg.msge("请完善合同信息后再提交！");
					        return false;
					    }
					});
					if (!subflag3||!subflag4) {
						return;
					}
					if(cate == "CT-ZL") {
						var total = 0;
						for (var i=0;i<this.formInline.paymentList.length;i++){
							var p = this.formInline.paymentList[i];
							total += parseDouble(this.isEmpty(p.paymentRatio)?0:p.paymentRatio);
						}
						if (total!=100){
							this.$msg.msge("付款比例总和不为100%");
							return;
						}
								//产品
						var totalMoney = new big(0);

						for (var i=0;i<this.formInline.zlList.length;i++){
							var q = this.formInline.zlList[i];
							totalMoney=totalMoney.plus(new big(q.productUnitPrice).times(q.rentNum));

						}
						console.log(totalMoney+"adsd");
						if (totalMoney!= this.formInline.contractAmount){
							this.$msg.msge("产品总价不等于合同金额");
							return;
						}
					}

				} else if (cate != "CT-BZ" && cate != "CT-DLS-KJ") {
					var cond = this.formInline1.condition;
					if (cond.indexOf("现金")!=-1){
						if (this.isEmpty(this.formInline.cashAmount) || this.isEmpty(this.formInline.cashRatio)){
							this.$msg.msge("请填写现金信息");
							return;
						}
					} else {
						if (this.isNotEmpty(this.formInline.cashAmount) || this.isNotEmpty(this.formInline.cashRatio)){
							this.$msg.msge("现金选项未勾选");
							return;
						}
					}
					if (cond.indexOf("信贷")!=-1){
						if (this.isEmpty(this.formInline.creditAmount) || this.isEmpty(this.formInline.creditRatio)){
							this.$msg.msge("请填写信贷信息");
							return;
						}
					} else {
						if (this.isNotEmpty(this.formInline.creditAmount) || this.isNotEmpty(this.formInline.creditRatio)){
							this.$msg.msge("信贷选项未勾选");
							return;
						}
					}
					var ratio1 = parseInt(this.isEmpty(this.formInline.cashRatio) ? 0 : this.formInline.cashRatio);
					var ratio2 = parseInt(this.isEmpty(this.formInline.creditRatio) ? 0 : this.formInline.creditRatio);
					if (ratio1 + ratio2 != 100) {
						this.$msg.msge("现金和信贷比例总和不为100%");
						return;
					}
					var amount1 = parseInt(this.isEmpty(this.formInline.cashAmount) ? 0 : this.formInline.cashAmount);
					var amount2 = parseInt(this.isEmpty(this.formInline.creditAmount) ? 0 : this.formInline.creditAmount);
					var amount = parseInt(this.formInline.contractAmount);
					if (amount1 + amount2 != amount) {
						this.$msg.msge("现金和信贷总和不等于合同金额");
						return;
					}
					this.formInline.payCondition = cond.join(",");
				}
				this.$msg.confirm("确定要提交吗？",()=>{
					this.formInline.editStatus = 1;
					this.formInline.contractType = 1;
					this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
					this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
					this.formInline.payDate = this.formatDate(this.formInline.payDate);
					this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
					if (this.formInline.paymentList) {
						this.formInline.paymentList.forEach((obj)=>{
							obj.billDate = this.formatDate(obj.billDate);
						})
					}
					//this.formInline.zlList = this.formInline.zlList;
					ss.contractService.insert(this.formInline).then(rd=>{
						if(rd.f){
							this.$msg.msgs("提交成功！");
							this.$router.push("contract-list");
						}else{
							this.$msg.msge("提交失败！"+rd.msg);
						}
					})
				})
			},
			getLEG(){
				var contNo = this.formInline.contractCode;
				var customerNo = this.formInline.companycode;
				if (this.isNotEmpty(contNo) && this.isnotEmpty(customerNo)) {
					ss.contractService.getLEG({"contNo":contNo,"customerNo":customerNo,"contractId":this.contractId}).then(rd => {
						this.formInline.contractAmount = rd.obj.contractAmount;
					})
				}
			},
			isEmpty(attr) {
				if (attr == null || attr == "") {
					return true;
				} else {
					return false;
				}
			},
			isNotEmpty(attr) {
				if (attr != null && attr != "") {
					return true;
				} else {
					return false;
				}
			},
			changeCatogory(attr){
				var usertype = 1;//经销商
				if (attr == "CT-CG" || attr == "采购合同") {
					usertype = 2;//供应商
					this.cgflag = true;
					this.zlflag = false;
					this.bzflag = false;
					this.customerlabel = "供应商名称";
					this.formInline.paymentList[0].nodeName = "";
					this.allProjectByUser = this.tempProject2;
				} else if (attr == "CT-ZL" || attr == "租赁合同"){
					this.cgflag = false;
					this.zlflag = true;
					this.bzflag = false;
					this.customerlabel = "客户名称";
					this.formInline.paymentList[0].newflag = true;
					this.formInline.paymentList[0].nodeName = "";
				} else if (attr == "CT-BZ" || attr == "标准合同") {
					this.bzflag = true;
					this.cgflag = false;
					this.zlflag = false;
					this.customerlabel = "客户名称";
					this.allProjectByUser = this.tempProject;
				} else if (attr == "CT-DLS-KJ" || attr == "经销商框架合同") {
					this.bzflag = false;
					this.cgflag = false;
					this.zlflag = false;
					this.dlsflag = true;
					this.customerlabel = "客户名称";
					this.allProjectByUser = this.tempProject;
				}else {
					this.cgflag = false;
					this.zlflag = false;
					this.bzflag = false;
					this.customerlabel = "客户名称";
					this.allProjectByUser = this.tempProject;
				}
				this.customerList = [];
				if (attr != "CT-CG" && attr != "采购合同") {
					ss.contractService.getCustomerList({usertype:usertype,status:1}).then(rd=>{
						this.customerList = rd;
					});
				}
			},
			formatDate(date){
				if (this.isNotEmpty(date)) {
					function addDateZero(num) {
						return (num < 10 ? "0" + num : num);
					}
					let d = new Date(date);
					let format = d.getFullYear()+"-"+addDateZero(d.getMonth()+1)+"-"+addDateZero(d.getDate());
					return format;
				}
			},
			//产品大类初始化
			selectProduct1() {
			    ss.ProService.product1Select().then(rd => {
			    	this.optionsProduct1 = rd;
			    })
			},
		    //大类修改时，带出产品型号
			changeBig(row){
				ss.ProService.product2NoOemSelect(row.productType).then(rd => {
					row.optionsProduct2 = rd;
				})
			},
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
			// 关闭新手引导页
				closeIt(){
					this.showOrhide = false;
					if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				},
				nextStep(i){
					if(this.status ==1){
							this.status = 2;
					}else if(this.status ==2){
						if(this.checked){
							ss.salesList.toshow(this.toshow,this.checked).then(rd => {
								console.log(rd)
								this.showOrhide = false;
							})
						}else{
							ss.salesList.toshow(this.toshow,this.checked).then(rd => {
								console.log(rd)
								this.showOrhide = false;
							})
						}
					}
				},
        	},
		mounted() {
			//获取当前用户所有项目详情
			ss.OrderService.projectManagePageG().then(rd => {
				this.allProjectByUser = rd;
				this.tempProject = rd;
				this.tempProject2 = _.filter(rd,(pro)=>{
					return pro.type == 5;
				})
			});
			if (this.contractId != null) {
				ss.contractService.detail(this.contractId).then(rd=>{
					if (this.isNotEmpty(rd.obj.contractCatecory)) {
						this.changeCatogory(rd.obj.contractCatecory);
					}
					if(rd.obj.contractCatecory == "CT-ZL") {
						rd.obj['fukuanobj'] = [];
						this.formInline = rd.obj;
						console.log(this.formInline.fukuanobj+"婕宝贝");

						this.formInline.fukuanobj.push({nodeName:"押金",paymentRatio:rd.obj.contractCashRadio,paymentDays:rd.obj.contractCashDays,
									newflag:false,netValue:rd.obj.contractCashNetValue,paymentAmount:rd.obj.contractCashPledge});
					}

					this.formInline = rd.obj;
					this.formInline1.wuliufangshi = this.formInline.wuliufangshi;
					this.formInline.paymentList = this.isEmpty(this.formInline.paymentList)?[{nodeName:"",newflag:false,paymentRatio:"",
							paymentAmount:"",netValue:"",paymentDays:"",isNeedcred:"",billDate:""}]:this.formInline.paymentList;
					if (this.formInline.payCondition != null) {
						if (this.formInline.payCondition.indexOf("现金") != -1) {
							this.formInline1.condition.push("现金");
						}
						if (this.formInline.payCondition.indexOf("信贷") != -1) {
							this.formInline1.condition.push("信贷");
						}
					}
					if (this.formInline.paymentList != null) {
						var flag = 0;
						for(var i=0;i<this.formInline.paymentList.length;i++){
							var p = this.formInline.paymentList[i];
							if(p.nodeName == "质保金" && flag==0) {
								p.newflag = false;
								flag = 1;
							}else {
								p.newflag = true
							}
						}
					}
				})
			} else {
				// this.formInline.id=util.getUuid();
				// this.contractId=this.formInline.id;
				var coflag = {
					codeflag: 5
				}
				ss.contractService.getContractCode(coflag).then(rd => {
					var date = new Date();
					var year = date.getFullYear();
					var month = date.getMonth() + 1;
					var day = date.getDate();
					if (month < 10) {
						month = 0 + month.toString();
					}
					this.formInline.id = year.toString()+month.toString()+day.toString()+"LEG"+rd;
					this.contractId = this.formInline.id;
					console.log(year.toString()+month.toString()+day.toString());
					console.log(this.formInline.id);
				})
			};
			this.selectProduct1();
		},
		created() {
			this.showzhezhao();
		}
    }
</script>

<style>
/* .h-formbLine .el-form-item__label{
	width: 18%;
} */
.yearIcon .el-input:after {
  content: '年';
  font-size: 0.18rem;
  color: #b8b6b6;
  /* font-weight: bold; */
  position: absolute;
  right: 0.15rem;
}
.weekplandetail21 .h-formbLine .el-form-item__label{
	width: 34%;
	text-align: right;
}
.weekplandetail21 .h-formbLine .el-form-item__content{
	width: 66%;
}
.weekplandetail21 .h-formbLine .h-elformWrap-2{
	width: 33.333%;
	padding-right: 0.5rem
}
.weekplandetail21 .h-formbLine .h-elformWrap-1{
	width: 100%;
	padding-right: 0.5rem
}
.weekplandetail21 .h-formbLine .h-elformWrap-1 .el-form-item__label{
	width: 10.4%;
}
.weekplandetail21 .h-formbLine .h-elformWrap-1 .el-form-item__content{
	width: 89.6%;
}
.ljjtips .el-table tbody td .cell{
	padding: 0.05rem 0.1rem 0.18rem 0.1rem;
}
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 3.1rem;
			left: 3.2rem;
			width: 4rem;
			height: 1.9rem;
		}
		.step2{
			top: 5.2rem;
			left: 3.7rem;
			width: 13.9rem;
			height: 2.2rem;
		}

		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
